import { css } from 'styled-components';
import { Sizes } from './types';

export const stylesOfSizes = {
  [Sizes.FLEX]: css`
    min-height: 43px;
    width: initial;
    overflow: initial;
    text-overflow: initial;
    white-space: initial;
    line-height: 16px;
    padding: 7px 0;
  `,
  [Sizes.LARGE]: css`
    height: 48px;
    width: 150px;
  `,
  [Sizes.NORMAL]: css`
    height: 43px;
    width: 150px;
    line-height: 16px;
    padding: 7px 0;
  `,
  [Sizes.TINY]: css`
    height: 34px;
    max-width: 150px;
  `,
};
